/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Image_AltInputs */

const vi_shop_image_alt = /** @type {(inputs: Shop_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả ảnh (alt)`)
};

/**

* @param {Shop_Image_AltInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_image_alt = /** @type {((inputs?: Shop_Image_AltInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Image_AltInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_image_alt(inputs)
});